module.exports = __webpack_public_path__ + "static/media/camouflage-leatherworking-tool.b0c22ab8.webp";